import { render, staticRenderFns } from "./EtimCombinationDetail.vue?vue&type=template&id=1747ab16&"
import script from "./EtimCombinationDetail.vue?vue&type=script&lang=js&"
export * from "./EtimCombinationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports